import React, { Component } from "react";
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';

import Avatar from "../../../ui/Avatar/Avatar";

import "./ConsultantItem.scss";

class ConsultantItem extends Component {
  static propTypes = {
    consultant: PropTypes.object.isRequired,
    onClickConsultant: PropTypes.func.isRequired,
  };

  createHint = (e) => {
    const { consultant } = this.props;
    if (consultant.status === 'DISABLED') {
      const hint = document.createElement('div');
      hint.id = 'hint-blocked';
      hint.textContent = 'Заблокирован';
      document.body.appendChild(hint);
      //Координаты хинта
      this.setHintCoordinates(hint, e);
    }
  }

  setHintCoordinates = (hint, e) => {
    if (hint !== null) {
      const hintWidth = hint.offsetWidth;
      const rightX = (e.pageX + (hintWidth/2));
      const diff = rightX - document.body.offsetWidth;
      const basicLeft = (e.pageX - (hintWidth/2));
      if(diff < 0 ) hint.style.left = basicLeft + 'px';
      else hint.style.left = (basicLeft - diff) + 'px';
      hint.style.top = e.pageY + 10 + 'px';
    }
  }

  destroyHint = () => {
    const { consultant } = this.props;
    if (consultant.status === 'DISABLED') {
      const hint = document.getElementById('hint-blocked');
      if (hint) hint.remove();
    }
  }

  getMouseСoordinates = e => {
    const { consultant } = this.props;
    if (consultant.status === 'DISABLED') {
      const hint = document.getElementById('hint-blocked');
      //Координаты хинта
      this.setHintCoordinates(hint, e);
    }
  }

  onClickConsultantItem = () => {
    const { consultant, onClickConsultant } = this.props;
    if (consultant.status === 'DISABLED') this.destroyHint();
    onClickConsultant(consultant.id);
  }

  render() {
    const { consultant } = this.props;

    const rowClass = classnames({
      'consultant': true,
      'row': true,
      'blocked': consultant.status === 'DISABLED',
    }); 
    
    const countClass = classnames({
      'col': true,
      'clients-count': true,
      'zero': consultant.clients_count === 0,
    }); 

    return (
      <div
        className={rowClass}
        onClick={() => this.onClickConsultantItem()}
        onMouseEnter={(e) => this.createHint(e)}
        onMouseLeave={(e) => this.destroyHint(e)}
        onMouseMove={(e) => this.getMouseСoordinates(e)}
      >
        <div className="ava">
          <Avatar avatar={consultant.avatar} />
        </div>
        <div className="cols-wrap">
          <div className="col cons-id">{consultant.external_id}</div>
          <div className="col cons-date">{moment(consultant.created_at).format('DD.MM.YYYY')}</div>
          <div className={countClass}>{consultant.clients_count}</div> 
        </div>
      </div>
    );
  }
}

export default ConsultantItem;
